// dataSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { firestore } from '../../firebase';


export const fetchLegalNoticeData = createAsyncThunk(
  'data/fetchLegalNoticeData',
  async () => {
    try {
      const snapshot = await firestore.collection('LegalNotice').get();
      const legalNoticeData = snapshot.docs.map((doc) => {
        const data = doc.data();
        data.uid = doc.id; // Add the uid to the data object
        return data;
      });
      return legalNoticeData;
    } catch (error) {
      throw error;
    }
  }
);

export const removeLegalNoticeItem = createAsyncThunk(
  'data/removeLegalNoticeItem',
  async (uid, { dispatch }) => {
    try {
      // Remove the item from the Firebase collection using its uid
      await firestore.collection('LegalNotice').doc(uid).delete();

      // After successfully removing, dispatch fetchLegalNoticeData to update the data
      dispatch(fetchLegalNoticeData());
    } catch (error) {
      console.error('Error removing legal notice item:', error);
      throw error; // Propagate the error
    }
  }
);

  export const addLegalNotice = createAsyncThunk(
    'data/addLegalNotice',
    async (newItem, { dispatch }) => {
      try {
        await firestore.collection('LegalNotice').add(newItem);
        dispatch(fetchLegalNoticeData());
      } catch (error) {
        console.error('Error adding legal notice:', error);
        throw error; // Propagate the error
      }
    }
  );
  
  export const fetchPrivacyPolicyData = createAsyncThunk(
    'data/fetchPrivacyPolicyData',
    async () => {
      try {
        const snapshot = await firestore.collection('PrivacyPolicy').get();
        const privacyPolicyData = snapshot.docs.map((doc) => {
          const data = doc.data();
          data.uid = doc.id; // Add the uid to the data object
          return data;
        });
        return privacyPolicyData;
      } catch (error) {
        throw error;
      }
    }
  );
  
  export const fetchTermsConditionsData = createAsyncThunk(
    'data/fetchTermsConditionsData',
    async () => {
      try {
        const snapshot = await firestore.collection('TermsAndConditions').get();
        const termsConditionsData = snapshot.docs.map((doc) => {
          const data = doc.data();
          data.uid = doc.id; // Add the uid to the data object
          return data;
        });
        return termsConditionsData;
      } catch (error) {
        throw error;
      }
    }
  );
  

  export const removePrivacyPolicyItem = createAsyncThunk(
    'data/removePrivacyPolicyItem',
    async (uid, { dispatch }) => {
      try {
        await firestore.collection('PrivacyPolicy').doc(uid).delete();
        dispatch(fetchPrivacyPolicyData());
      } catch (error) {
        console.error('Error removing privacy policy item:', error);
        throw error;
      }
    }
  );
  
  export const removeTermsConditionsItem = createAsyncThunk(
    'data/removeTermsConditionsItem',
    async (uid, { dispatch }) => {
      try {
        await firestore.collection('TermsAndConditions').doc(uid).delete();
        dispatch(fetchTermsConditionsData());
      } catch (error) {
        console.error('Error removing terms and conditions item:', error);
        throw error;
      }
    }
  );
  
  export const addPrivacyPolicy = createAsyncThunk(
    'data/addPrivacyPolicy',
    async (newItem, { dispatch }) => {
      try {
        await firestore.collection('PrivacyPolicy').add(newItem);
        dispatch(fetchPrivacyPolicyData());
      } catch (error) {
        console.error('Error adding privacy policy:', error);
        throw error;
      }
    }
  );
  
  export const addTermsConditions = createAsyncThunk(
    'data/addTermsConditions',
    async (newItem, { dispatch }) => {
      try {
        await firestore.collection('TermsAndConditions').add(newItem);
        dispatch(fetchTermsConditionsData());
      } catch (error) {
        console.error('Error adding terms and conditions:', error);
        throw error;
      }
    }
  );

// Create a data slice
const dataSlice = createSlice({
  name: 'data',
  initialState: {
    legalNoticeData: [],
    privacyPolicyData: [],
    termsConditionsData: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLegalNoticeData.fulfilled, (state, action) => {
        state.legalNoticeData = action.payload;
      })
      .addCase(fetchPrivacyPolicyData.fulfilled, (state, action) => {
        state.privacyPolicyData = action.payload;
      })
      .addCase(fetchTermsConditionsData.fulfilled, (state, action) => {
        state.termsConditionsData = action.payload;
      });
  },
});

export default dataSlice.reducer;
